/**
 * Страница «Сила в слове» (`/silavslove/`).
 *
 * Перенесено из инлайн-`<script>` шаблона `page-silavslove.php`
 * (Этап 6 §0, группа 2, 👤 указание владельца).
 *
 * Два независимых блока:
 *   • `.reviews--silavslove` — отзывы, 1 слайд до 992px, 3 выше;
 *   • `.workshop` — аккордеон воркшопов, раскрытие по клику.
 *
 * 🔴 Якорь отзывов — модификатор `.reviews--silavslove`, а не общий
 * `.reviews__slider`. Тот же класс есть на главной (`front-page.php`,
 * секция `.reviews--front-page`), и её слайдер заводит легаси
 * `assets/js/page-front.js`. С общим якорем модуль создавал на главной
 * ВТОРОЙ инстанс Swiper на том же элементе и забирал стрелки блоков
 * «Блог» и «Медиа» — они листали отзывы (замер 2026-11-02).
 */

/**
 * Отзывы.
 *
 * ⚠️ `spaceBetween` на мобильной ширине НЕ задан — так было в инлайне.
 * Отступ между слайдами там берётся из CSS страницы, менять нельзя:
 * визуальный регресс поймает.
 *
 * ⚠️ `slidesPerView: 3.0001` вместо 3 — тоже из инлайна. Дробное
 * значение заставляет Swiper показать край четвёртого слайда,
 * то есть это намеренная подсказка «листать дальше», а не опечатка.
 */
const REVIEWS = {
    loop: true,
    slidesPerView: 1,
    breakpoints: {
        992: {
            slidesPerView: 3.0001,
            spaceBetween: 40,
        },
    },
};

/** Аккордеон воркшопов: клик по кнопке переключает раскрытие. */
function initWorkshops() {
    const items = document.querySelectorAll('.workshop');
    if (!items.length) return;

    for (const item of items) {
        const btn = item.querySelector('.workshop__btn');
        if (!btn) continue;

        btn.addEventListener('click', () => {
            item.classList.toggle('workshop--active');
        });
    }
}

export default async function SilavsloveSliders() {
    initWorkshops();

    const section = document.querySelector('.reviews--silavslove');
    const slider = section && section.querySelector('.reviews__slider');
    if (!slider) return;

    const [{ default: Swiper }, { Navigation }] = await Promise.all([
        import('swiper'),
        import('swiper/modules'),
    ]);

    // Стрелки — элементами из своей секции, а не строкой: строку
    // Swiper ищет по всему документу.
    //
    // Модуль перечисляется явно: в вендорном бандле навигация была
    // встроена, в npm-сборке без этого стрелки просто не заработают
    new Swiper(slider, {
        ...REVIEWS,
        modules: [Navigation],
        navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
        },
    });
}
